<template>
  <div class="form-area">
    <div class="form-black-titile">
      查詢申請狀況Application Status Enquiry
    </div>

    <el-row :gutter="10" class="form-row">
      <el-col :span="4">
        <div class="form-label">申請編號 *</br> Application ID</div>
      </el-col>
      <el-col :span="6">
        <div class="form-label">{{queryResult.applyCode}}</div>
      </el-col>
    </el-row>

    <el-row :gutter="10" class="form-row">
      <el-col :span="4">
        <div class="form-label">申請狀態 *</br> Application Status</div>
      </el-col>
      <el-col :span="5">
        <div class="form-label">
           <dict-tag :options="dict.type.apply_status" :value="queryResult.applyStatus" />
          </div>
      </el-col>
    </el-row>

    <div class="btn-box">
      <el-col :span="4"></el-col>
      <el-button class="next-btn" type="warning" round @click="handleHome">返回主頁<br> Return to home page</el-button>
    </div>
  </div>
</template>

<script>
export default {
  dicts:["apply_status"],
  data() {
    return {
      queryResult: this.Session.get("queryResult"),
    };
  },
  methods: {
    handleHome() {
      this.$store.commit("FINISH_SETP");
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/query/child/result.vue